// @ts-nocheck
/* Store Sync - OrderHistorySearchFieldDateRange */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { tableFilterProps } from "@store/Themes/common/props/table";
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistoryDeliveryDateRangeStyles {
    searchFieldWrapper?: SearchFieldWrapperStyles;
    datePickersWrapper?: InjectableCss;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    // Starter Custom Code
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const dateDeliveryRangeStyles: OrderHistoryDeliveryDateRangeStyles = {
    gridContainer: tableFilterProps.formGridContainer,
    gridItem: { width: [12, 6, 6, 6, 6] },
};

const styles = dateDeliveryRangeStyles;

const OrderHistorySearchFieldDeliveryDateRange: React.FunctionComponent<Props> = props => {
    const fromDeliveryDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        const loadParameter = {
            ...props.parameter,
            fromDeliveryDate: convertDateToDateOnlyString(selectedDay),
        };
        props.updateSearchFields(loadParameter);
    };

    const toDeliveryDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        const loadParameter = {
            ...props.parameter,
            toDeliveryDate: convertDateToDateOnlyString(selectedDay),
        };
        props.updateSearchFields(loadParameter);
    };

    const fromDeliveryDate = convertDateOnlyStringToDate(props.parameter.fromDeliveryDate);
    const toDeliveryDate = convertDateOnlyStringToDate(props.parameter.toDeliveryDate);

    return (
        <SearchFieldWrapper extendedStyles={styles.searchFieldWrapper}>
            <StyledWrapper {...styles.datePickersWrapper} data-test-selector="orderHistory_filterDeliveryDateRange">
                <GridContainer {...styles.gridContainer} /* Starter Custom Code */>
                    <GridItem {...styles.gridItem} /* Starter Custom Code */>
                        <DatePicker
                            data-test-selector="orderHistory_filterFromDeliveryDate"
                            {...styles.fromDate}
                            label={translate("Requested Delivery Date From") /* Store Custom Code */}
                            selectedDay={fromDeliveryDate}
                            onDayChange={fromDeliveryDateChangeHandler}
                            dateTimePickerProps={{
                                clearIcon: null,
                                maxDate: toDeliveryDate,
                                ...styles.fromDate?.dateTimePickerProps,
                            }}
                        />
                    </GridItem>
                    <GridItem {...styles.gridItem}>
                        <DatePicker
                            data-test-selector="orderHistory_filterToDeliveryDate"
                            {...styles.toDate}
                            label={translate("Requested Delivery Date To") /* Store Custom Code */}
                            selectedDay={toDeliveryDate}
                            onDayChange={toDeliveryDateChangeHandler}
                            dateTimePickerProps={{
                                clearIcon: null,
                                minDate: fromDeliveryDate,
                                ...styles.toDate?.dateTimePickerProps,
                            }}
                        />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldDeliveryDateRange),
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Delievery Date Range",
    },
};

export default widgetModule;
